module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00054.424634d1.jpg";